import { render } from "./App.vue?vue&type=template&id=0efd8057"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0efd8057&lang=less"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__